import {
  checkType,
  CtyShowToast,
  getPalUrl,
  getPalSessionMode,
  injectPalChatbot,
  useScreenWidth,
  type SidebarItem,
  SidebarItemType,
} from '@circuitry-ai/doc-ui';
import { useTranslation } from 'react-i18next';

const SidebarItems = (isCollapsed: boolean, handleToggleSidenav: () => void) => {
  const { t } = useTranslation();
  const width = useScreenWidth();
  const isMobile = width < 640;

  return [
    {
      key: 'toggle',
      title: t('Toggle'),
      icon: 'solar:hamburger-menu-outline',
      className: 'mb-4 mt-1',
      show: isCollapsed,
    },
    {
      key: 'dashboard',
      href: '/',
      icon: 'radix-icons:home',
      title: t('Dashboard'),
      show: true,
    },
    {
      key: 'journeys',
      href: '/aiworkers/list/journeys',
      icon: 'oui:nav-ai-flow',
      title: t('Journeys'),
      show: true
    },
    {
      key: 'octr',
      title: t('AI Workers'),
      type: SidebarItemType.Nest,
      items: [
        {
          key: 'advisors',
          href: '/advisors',
          icon: 'solar:glasses-linear',
          title: t('Advisors'),
          show: true,
        },
        {
          key: 'analyst',
          href: '/analytics',
          icon: 'system-uicons:graph-box',
          title: t('Analysts'),
          show: true
        },
        {
          key: 'agents',
          href: '/agents',
          icon: 'material-symbols-light:graph-2',
          title: t('Agents'),
          show: true
        }
      ]
    },
    {
      key: 'agent',
      title: t('Sources'),
      type: SidebarItemType.Nest,
      items: [
        {
          key: 'knowledge',
          href: '/knowledge',
          icon: 'lucide:copy-check',
          title: t('Knowledge'),
          show: true,
        },
        {
          key: 'actions',
          href: '/actions',
          icon: 'streamline:target',
          title: t('Actions'),
          show: true,
        },
        {
          key: 'data',
          href: '/data',
          icon: 'solar:database-outline',
          title: t('Data'),
          show: true,
        }
      ]
    },
    {
      key: 'activity',
      title: t('Activity'),
      type: SidebarItemType.Nest,
      items: [
        {
          key: 'conversations',
          href: '/conversations',
          icon: 'ph:chat-text',
          title: t('Conversations'),
          show: true,
        },
        {
          key: 'history',
          href: '/history',
          icon: 'iconoir:page-search',
          title: t('History'),
          show: true
        },
        {
          key: 'triage',
          href: '/triage',
          icon: 'solar:danger-circle-linear',
          title: t('Triage'),
          show: true
        }
        // {
        //   key: 'conversationwithmilves',
        //   href: '/search-with-milvus',
        //   icon: 'ph:chat-text',
        //   title: t('Search With Milves'),
        // }
      ]
    },
    {
      key: 'sys',
      title: t('System'),
      type: SidebarItemType.Nest,
      items: [
        {
          key: 'help',
          // href: "/help",
          icon: 'tdesign:support',
          title: t('Support'),
        },
        {
          key: 'settings',
          href: '/settings',
          icon: 'qlementine-icons:settings-16',
          title: t('Settings'),
          show: true,
        }
      ],
    },
    {
      key: 'pal',
      title: t('Open PAL'),
      type: SidebarItemType.Nest,
      show: isMobile,
      items: [
        {
          key: 'New PAL Window',
          icon: 'fluent:window-new-20-regular',
          title: t('New PAL Window'),
          onClick: () => {
            const palUrl = getPalUrl();
            if (palUrl) {
              window.open(palUrl, '_blank', 'noopener,noreferrer');
            }
          },
        },
        {
          key: 'Widget',
          icon: 'heroicons:chat-bubble-left-right',
          title: t('Widget'),
          onClick: () => {
            injectPalChatbot(CtyShowToast, checkType, undefined, {
              open: true,
              resolveTargetMode: () => getPalSessionMode(),
            });
          },
        },
      ],
    },
  ] as SidebarItem[];
};

export default SidebarItems;
